import React, { useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Layout from "components/Layout";
//import PopupLayout from 'components/PopupLayout';
//import PopupCouponRank from 'components/PopupCouponRank';
import CouponSlider from "components/CouponSlider";
import SessionFactory from "factories/Session";
import CartFactory from "factories/Cart";
import CartService from "services/Cart/service";
import IconClose from "assets/images/category/icon-close.png";
import BgChange from "assets/images/account/background-change.png";
import { documentTypes, main_links } from "../../config";
import { CartContext } from "../../cart/CartContext";
import { types } from "../../types/types";
import "./style.scss";
import { leftPad } from "config/utils";
import PopupLayout from "components/PopupLayout";
import PopupLimiteHCanjearLiberar from "components/PopupLimiteHCanjearLiberar";
import moment from 'moment';

const AccountCouponsChange = ({ match }) => {
    const { cartDispatch } = useContext(CartContext);
    const [validCart, setValidCart] = useState(true);
    const [payloadData, setPayloadData] = useState("");
    const [stepChange, setStepChange] = useState(1);
    const [timeLeft, setTimeLeft] = useState("00-00-0000 00:00");
    const [typeCart, setTypeCart] = useState(0);
    const [showLimiteHCanjear, setShowLimiteHCanjear] = useState(false);
    const [cantCupTotalLHCanjear, setCantCupTotalLHCanjear] = useState();
    const [cantCupConsumidosLHCanjear, setCantCupConsumidosLHCanjear] = useState();
    /*
    const [showRank, setShowRank] = useState(false);
    const openRank = (event, forceValue = 'none') => {
        event.preventDefault();
        setShowRank(forceValue === 'none' ? !showRank : (forceValue));
    }
    const confirmRank = () => {
        console.log("ranking submit!!!");
    }
    */
    useEffect(() => {
        Promise.all([CartService.getLastCart()]).then((cartLast) => {
            if (cartLast && ["200", "201"].includes(cartLast[0].internalCode)) {
                localStorage.setItem("maxLimit", cartLast[0].payload.maxItems);
                let cart = CartFactory.initLastCart(cartLast[0].payload);
                //
                //popup Canjear
                const coupons = cartLast[0].payload;
                if (coupons.cantCupConsumidosTotalLH > 0) {
                    valuePopupLimiteCanjear(
                        true,
                        coupons.cantCupConsumidosTotalLH,
                        coupons.cantCupTotalLH
                    );
                }
                //end popup canjear

                //modify array attribute cuponBonus in cupon personalizado
                let cartCoupons = cartLast[0].payload.detalle;
                cartCoupons.map(function (dato) {
                    if (dato.personalizado == true) {
                        dato.cuponBonus = false;
                    }
                    return dato;
                });
                

                // update expiracion with coupon vencimiento
                var daysLH = releaseDay(cartLast[0].payload);
                //update with hour limite horizontal
                var hoursLH = releaseHour(cartLast[0].payload);

                //-set variables bonus and personalizado
                let cuponBonusCart = cartCoupons
                    .map((element) => element.cuponBonus)
                    .includes(true);
                let cuponPersonalizadoCart = cartCoupons
                    .map((element) => element.personalizado)
                    .includes(true);
                cuponBonusCart == false &&
                    cuponPersonalizadoCart == false &&
                    setTypeCart(0);
                cuponBonusCart == true &&
                    cuponPersonalizadoCart == false &&
                    setTypeCart(1);
                cuponBonusCart == false &&
                    cuponPersonalizadoCart == true &&
                    setTypeCart(2);
                cuponBonusCart == true &&
                    cuponPersonalizadoCart == true &&
                    setTypeCart(3);

                if (cart.state === "L") {
                    if (
                        `${cart.id}`.replace(/^[\d]{3}/, "") ===
                        match.params.id.replace(/^[\d]{3}/, "")
                    ) {
                        cartDispatch({
                            type: types.update,
                            payload: cart,
                        });
                        setPayloadData(cartLast[0].payload);

                        timeAnimate(
                            cartLast[0].payload.updateAt,
                            daysLH,
                            hoursLH
                        );

                        setTimeout(function () {
                            setStepChange(2);
                            //setShowRank(true);
                        }, 2500);
                    } else {
                        setValidCart(false);
                    }
                } else {
                    setValidCart(false);
                }
            } else {
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.reset(),
                });
            }
        });
    }, []);

    const timeAnimate = (createAt, days, horaFinal) => {
        createAt =
            createAt && createAt !== ""
                ? createAt.replace("-", "/").replace("-", "/")
                : "";
        const _date =
            createAt && createAt !== ""
                ? new Date(
                      createAt.includes(":") ? createAt : createAt + " 00:00:00"
                  )
                : "";
        const endDate = new Date();
        endDate.setTime(_date.getTime() + days * 24 * 60 * 60 * 1000);

        const _day = leftPad(endDate !== "" ? endDate.getDate() : 0, 2, "0");
        const _month = leftPad(
            endDate !== "" ? endDate.getMonth() + 1 : 0,
            2,
            "0"
        );
        const _year =
            endDate !== "" ? endDate.getFullYear().toString().substr(-2) : "00";

        let end = `${_day}.${_month}.${_year} ${horaFinal}`;

        setTimeLeft(end);
    };
    const openLimiteHCanjear = (event, forceValue = "none") => {
        event.preventDefault();
        setShowLimiteHCanjear(
            forceValue === "none" ? !showLimiteHCanjear : forceValue
        );
    };
    const valuePopupLimiteCanjear = (showValue, cupConsumidos, cupTotal) => {
        setShowLimiteHCanjear(showValue);
        setCantCupConsumidosLHCanjear(cupConsumidos);
        setCantCupTotalLHCanjear(cupTotal);
    };

    //return  next day or the present day
    const releaseDay = (cartLastPayload) => {
        var days;
        if (cartLastPayload.horaLH !== null) {
            return (days = 0);
        } else {
            let cartCoupons = cartLastPayload.detalle;

            // update expiracion with coupon vencimiento
            let arrayVencimiento = cartCoupons.map(
                (element) => new Date(element.vencimiento)
            );
            //minimo update vencimiento
            var minVencimiento = new Date(
                Math.min.apply(null, arrayVencimiento)
            );
            var updateAtCoupon = new Date(cartLastPayload.updateAt);
            minVencimiento <= updateAtCoupon ? (days = 0) : (days = 1);
            return days;
        }
    };
    //return  hour LH or 23:59
    const releaseHour = (cartLastPayload) => {
        //update with hour limite horizontal
        var horaLH = cartLastPayload.horaLH;
        if (horaLH != null) {
            var fechaUpdate = moment(`${cartLastPayload.updateAt} UTC`).add(horaLH, 'hours');

            return "a las " + fechaUpdate.format("HH:mm");
        } else {
            return "a las 23:59";
        }

        //
    };

    return (
        <div className="mi-cuenta canje paso-1 is-logged">
            <Layout>
                <section className="coupons-search">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 pt-4 pb-4">
                                <div className="row pl-2 pr-2">
                                    <div className="col-10 col-lg-6 d-flex justify-content-lg-start align-content-center">
                                        <p className="text-left red-dark m-0 my-auto">
                                            <strong>
                                                Tus cupones seleccionados,
                                                <br />
                                                listos para canjear:
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="col-2 col-lg-6 d-flex justify-content-center justify-content-lg-end align-content-center">
                                        <p className="text-center m-0 my-auto">
                                            <a href={main_links.main_logged}>
                                                <img src={IconClose} />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="coupon-change">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 mt-2">
                                <p className="text-center m-0 time-left">
                                    Expira el <span>{timeLeft}</span>
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-8 mx-auto my-5">
                                        <p className="image mx-auto">
                                            <img
                                                src={BgChange}
                                                className="w-100"
                                            />
                                        </p>
                                    </div>
                                    <div className="col-12">
                                        <p className="text-center grey-darken-2">
                                            {SessionFactory.getItemSession(
                                                "firstname"
                                            )}{" "}
                                            tu código de cupón es:
                                        </p>
                                        <p className="text-center mb-4 change-code black">
                                            {payloadData.id}
                                        </p>
                                        {stepChange === 1 ? (
                                            <div>
                                                <p className="text-center note default-red">
                                                    Muestra este código en caja
                                                </p>
                                            </div>
                                        ) : (
                                            <>
                                                {typeCart === 0 && (
                                                    <p className="text-center note default-red">
                                                        Muestra este código en
                                                        caja
                                                    </p>
                                                )}
                                                {typeCart === 1 && (
                                                    <p className="text-center note default-red">
                                                        Presentar tu bonus al
                                                        momento de
                                                        <br />
                                                        canjearlo en caja
                                                    </p>
                                                )}
                                                {typeCart === 2 && (
                                                    <div>
                                                        <p className="text-center mb-4 note  default-red">
                                                            {
                                                                documentTypes.find(
                                                                    (
                                                                        document
                                                                    ) =>
                                                                        document.cod ==
                                                                        payloadData.tipoDocumento
                                                                ).title
                                                            }
                                                            :{" "}
                                                            {
                                                                payloadData.nroDocumento
                                                            }
                                                        </p>
                                                        <p className="text-center note default-red">
                                                            Presentar tu DNI al
                                                            momento de
                                                            <br />
                                                            canjearlo en caja
                                                        </p>
                                                    </div>
                                                )}
                                                {typeCart === 3 && (
                                                    <div>
                                                        <p className="text-center mb-4 note  default-red">
                                                            {
                                                                documentTypes.find(
                                                                    (
                                                                        document
                                                                    ) =>
                                                                        document.cod ==
                                                                        payloadData.tipoDocumento
                                                                ).title
                                                            }
                                                            :{" "}
                                                            {
                                                                payloadData.nroDocumento
                                                            }
                                                        </p>
                                                        <p className="text-center note default-red">
                                                            Presentar tu bonus y
                                                            tu DNI al momento de
                                                            <br />
                                                            canjearlo en caja
                                                        </p>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <p className="legend-login text-center">
                                            Puede visualizar este código en la
                                            Sección mis cupones
                                        </p>
                                    </div>
                                </div>
                                <div className="border">
                                    <div className="row coupons">
                                        <div className="col-12 mt-4">
                                            <CouponSlider
                                                coupons={payloadData.detalle}
                                                noslick={true}
                                                withoutAction={true}
                                                hasSession={true}
                                                hasCart={false}
                                                changeExpired={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*
                <PopupLayout isShowwing={showRank} showingCallback={openRank} showCloseButton={false}>
                    <PopupCouponRank execActionConfirm={confirmRank} />
                </PopupLayout>
                */}
                <PopupLayout
                    isShowwing={showLimiteHCanjear}
                    showingCallback={openLimiteHCanjear}
                >
                    <PopupLimiteHCanjearLiberar
                        execActionConfirm={openLimiteHCanjear}
                        cantCupConsumidosLH={cantCupConsumidosLHCanjear}
                        cantCupTotalLH={cantCupTotalLHCanjear}
                    />
                </PopupLayout>
                {!validCart && <Redirect to={main_links.main_logged} />}
            </Layout>
        </div>
    );
};

AccountCouponsChange.propTypes = {
    match: PropTypes.object,
};
export default AccountCouponsChange;
